import { Form, Row, Col, Button, InputGroup } from "react-bootstrap";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import Flatpickr from "react-flatpickr";
import {
  setActiveTab,
  setPaginationPageNumber,
  TriggerFilterButtonApi,
} from "../../slices/common/reducer";
import {
  filterDateOptions,
  handleFilterDateChange,
} from "../../Utils/CommonUtils";
import { setAgMemberFilterForm } from "../../slices/agMember/agMemberSlice";
import { AGM_FROM_DATE, AGM_TO_DATE } from "../../Utils/FilterDateKeys";
import { CiSearch } from "react-icons/ci";

const AgMemberFilter = () => {
  const dispatch = useDispatch();

  const filterForm = useSelector((state) => state.agMember.filter.form);

  const resetTabAndPageNumber = () => {
    dispatch(setPaginationPageNumber(0));
    dispatch(setActiveTab("ALL"));
  };

  const handleInputChange = (name, value) => {
    dispatch(setAgMemberFilterForm({ name, value }));
    resetTabAndPageNumber();
    dispatch(TriggerFilterButtonApi());
  };

  const handleClear = () => {
    dispatch(setAgMemberFilterForm({ type: "reset" }));

    dispatch(TriggerFilterButtonApi());

    if (Object.keys(filterForm).length > 0) {
      resetTabAndPageNumber();
    }
  };

  const agMemberOptions = [
    { value: "ACTIVE", label: "Active" },
    { value: "INACTIVE", label: "Inactive" },
  ];

  const isClearButtonDisabled = !Object.values(filterForm).some(
    (value) => value
  );

  return (
    <div className="filter-wrapper">
      <Form className="form-input">
        <Row>
          <Form.Group as={Col} className="col-md-4">
            <InputGroup>
              <InputGroup.Text id="basic-addon1">
                {" "}
                <CiSearch />
              </InputGroup.Text>
              <Form.Control
                type="text"
                placeholder="Search for Code, Name, Mobile, Email..."
                name="filter_ref"
                id="code"
                className="agm-searchbar"
                value={filterForm.filter_ref || ""}
                onChange={(e) =>
                  handleInputChange(e.target.name, e.target.value)
                }
              />
            </InputGroup>
          </Form.Group>
          <Form.Group as={Col} className="col-md-4">
            <Select
              isClearable
              placeholder="Status"
              name="status"
              options={agMemberOptions}
              value={
                agMemberOptions.find(
                  (itm) => itm.value === filterForm.status
                ) || null
              }
              onChange={(e) => handleInputChange("status", e ? e.value : "")}
            />
          </Form.Group>
          <Form.Group as={Col} className="col-md-3">
            <Flatpickr
              className="form-control border-lightgrey"
              placeholder="Select date"
              data-input
              options={filterDateOptions}
              value={[
                filterForm[AGM_FROM_DATE]
                  ? new Date(filterForm[AGM_FROM_DATE])
                  : null,
                filterForm[AGM_TO_DATE]
                  ? new Date(filterForm[AGM_TO_DATE])
                  : null,
              ]}
              onChange={(e) =>
                handleFilterDateChange(
                  e,
                  setAgMemberFilterForm,
                  AGM_FROM_DATE,
                  AGM_TO_DATE
                )
              }
            />
          </Form.Group>
          <Form.Group as={Col} className="col-md-1">
            <div>
              <Button
                className="primary-outline"
                onClick={handleClear}
                disabled={isClearButtonDisabled}
              >
                Clear
              </Button>
            </div>
          </Form.Group>
        </Row>
      </Form>
    </div>
  );
};

export default AgMemberFilter;
